import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { initEnvironment } from "./hooks/initEnvironment";
import Loader from "./hooks/loader";

const PresaleBootstrap = ({ Component }) => {
  const { projectTicker } = useParams();
  const [ready, setReady] = useState(false);
  const [projectId, setProjectId] = useState(null);

  useEffect(() => {
    if (!projectTicker) return;

    initEnvironment(projectTicker)
      .then((data) => {
        setReady(true);
        setProjectId(data?._id);
      })
      .catch((err) => {
        window.open("https://gems.vip/launchpad", "_self");
        console.error("Presale init failed", err);
      });
  }, [projectTicker]);

  if (!ready) return <Loader />;

  return <Component projectId={projectId} />;
};

export default PresaleBootstrap;
